import Vue from 'vue'
import Vuex from 'vuex'
import headerTabs from './module/headerTabs'
import menuList from './module/menuList'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: { // 模块引用
    menuList,
    headerTabs
  }
})
